import React from 'react';
import PropTypes from 'prop-types';
import ValuePropsModal from './ValuePropsModal';
import { FormattedMessage } from 'react-intl';
import BeforeAfter from 'images/B&A@2x.jpg';

const formattedTitle = (
  <FormattedMessage
    id="ValueProps.beforeAfter.title"
    description="Title for Before and After Feature"
    defaultMessage="Before & After Cam"
  />
);

const formattedDescription = (
  <FormattedMessage
    id="ValueProps.beforeAfter.description"
    description="Description for Before and After Feature"
    defaultMessage="Combine your before and after photos into a single image that shows off your work."
  />
);

const beforeAfterChecklist = [
  <FormattedMessage
    id="ValueProps.beforeAfter.valuePropA"
    description="Value Prop for Before and After Feature"
    defaultMessage="Choose photos from your projects"
  />,
  <FormattedMessage
    id="ValueProps.beforeAfter.valuePropB"
    description="Value Prop for Before and After Feature"
    defaultMessage="Pick a layout from our template gallery"
  />,
  <FormattedMessage
    id="ValueProps.beforeAfter.valuePropC"
    description="Value Prop for Before and After Feature"
    defaultMessage="Brand your image with your logo"
  />,
  <FormattedMessage
    id="ValueProps.beforeAfter.valuePropD"
    description="Value Prop for Before and After Feature"
    defaultMessage="Share on your website or social pages"
  />,
];

const BeforeAfterValuePropsModal = ({ isOpen, onRequestClose }) => {
  return (
    <ValuePropsModal
      title={formattedTitle}
      image={BeforeAfter}
      description={formattedDescription}
      checklistItems={beforeAfterChecklist}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      trialed={false}
    />
  );
};

export default BeforeAfterValuePropsModal;

BeforeAfterValuePropsModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
};
